import { StyleSheet } from 'react-native';
import React from 'react';
import Divider from 'theme/Divider';
import isEqual from 'react-fast-compare'
import { themedDividerStyle } from 'styles/components/atoms/ThemedDivider'

const TimeslotDivider = ( { style = {} } ) => {
	
	const viewStyle = [
		themedDividerStyle.divider,
		staticStyles.viewStyleMarginVertical12Width50,
		style
	]
	
	return (
		<Divider
			style={ viewStyle }
		/>
	)
}

const staticStyles = StyleSheet.create({
	viewStyleMarginVertical12Width50: {
		marginVertical: 12,
		width: '50%',
	},
});

export default React.memo( TimeslotDivider, isEqual );
